import { render, staticRenderFns } from "./StSeperationLineAnchor.vue?vue&type=template&id=5681bfb2"
import script from "./StSeperationLineAnchor.vue?vue&type=script&lang=ts"
export * from "./StSeperationLineAnchor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports